import Schema, { required } from 'AppReact/schema';

export default {
  title: Schema('string', 'primitive-nullable', { defaultValue: null }),
  value: Schema('string', 'primitive-nullable', { defaultValue: null }),
  valueLegend: Schema('string', 'primitive-nullable', { defaultValue: null }),
  compareValue: Schema('string', 'primitive-nullable', { defaultValue: null }),
  compareValueColor: Schema('string', 'primitive-nullable', { defaultValue: null }),
  compareText: Schema('string', 'primitive-nullable', { defaultValue: null }),
  hasArrow: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  arrowDirection: Schema('string', 'primitive-nullable', { defaultValue: null }),
  isClickable: Schema('string', 'primitive-nullable', { defaultValue: null }),
  isLoading: Schema('string', 'primitive-nullable', { defaultValue: null }),
}
